var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcgIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7521 7.37516L10.8271 5.5335L8.23548 10.7085C8.10215 10.9918 7.81048 11.1668 7.49382 11.1668C7.17715 11.1668 6.88548 10.9918 6.75215 10.7085L5.31048 7.8335H0.827148V12.0002C0.827148 12.9168 1.57715 13.6668 2.49382 13.6668H15.8271C16.7438 13.6668 17.4938 12.9168 17.4938 12.0002V7.8335H12.4938C12.1771 7.8335 11.8855 7.6585 11.7521 7.37516Z",
    fill: "#065A15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8271 0.333496H2.49382C1.57715 0.333496 0.827148 1.0835 0.827148 2.00016V6.16683H5.82715C6.14382 6.16683 6.43548 6.34183 6.56882 6.62516L7.49382 8.46683L10.0855 3.29183C10.3688 2.72516 11.2938 2.72516 11.5771 3.29183L13.0105 6.16683H17.4938V2.00016C17.4938 1.0835 16.7438 0.333496 15.8271 0.333496Z",
    fill: "#065A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcgIconSmall);
export default __webpack_public_path__ + "static/media/ecg-icon-small.9ef0e1751ca1a78b36f7b8e3d14ba5ca.svg";
export { ForwardRef as ReactComponent };